module.exports = __webpack_public_path__ + "static/media/ghd_banner_3.f5e1c1c4.png";